export default __webpack_public_path__ + "static/Development-&-experimentation-41d7bd75a25efab9a80673aeb8f9b139.webp";